import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
function Footer() {
  const logo = useSelector((state) => state.logo.logo);

  return (
    <div>
      <footer className="footer bg-base-200 text-base-content p-3 ">
        <div className="footer container mx-auto max-w-[1200px]">
          <aside>
            <img src={logo} alt="logo" className="w-32 h-32" />
            <p className="font-medium uppercase">
              Câu lạc bộ doanh nhân đồng hương Bạc Liêu - Cà Mau tại TP Cần Thơ
              (BCCU)
            </p>
          </aside>
          <nav>
            <h6 className="footer-title font-medium opacity-[100%]">Liên hệ</h6>
            <div className="link link-hover">
              Địa chỉ : Số 52, Đường B12, KDC Hưng Phú 1, Q. Cái Răng, Tp. Cần
              Thơ
            </div>
            <div className="link link-hover">
              Số điện thoại: 0939 168 552 ( Hồ Chí Hiệp - Trưởng ban thành viên)
            </div>
            <div className="link link-hover">
              Hotline: 0915 776 663 ( Trang Tuấn Kiệt - Chủ tịch)
            </div>
            <div className="link link-hover">
              Email: trangtuankiet@gmail.com
            </div>
          </nav>
         
          <div className="w-full md:w-auto">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d435.0004633541015!2d105.78858562903172!3d10.017736395738906!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a0628469906aff%3A0x5107ae5cb4f8ff50!2zNTIgxJDGsOG7nW5nIEIxMiwgS0RDIEjGsG5nIFBow7ogMSwgQ8OhaSBSxINuZywgQ-G6p24gVGjGoSwgVmnhu4d0IE5hbQ!5e1!3m2!1svi!2s!4v1740561447911!5m2!1svi!2s"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              title="gg Map"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </footer>
      <footer className="footer bg-base-200 text-base-content  md:px-10 px-3 py-4">
        <aside className="container mx-auto md:px-4 max-w-[1200px] flex justify-between items-center">
          <p className="font-medium border-l-2 border-gray-500 pl-2">
            Vận hành bởi BCCU
          </p>
          <p className="font-medium border-l-2 border-gray-500 pl-2">
            <Link to="https://thietkeweb.katec.vn/">Thiết kế bởi Katec</Link>
          </p>
        </aside>
      </footer>
    </div>
  );
}

export default Footer;
